import React from "react";
import TextField from "@material-ui/core/TextField";
import GetLabel from "./LabelComponent";

export default function ({ form, propName, ...passThroughProps }) {
  const { input, changeInput, schema, invalid, isRequired } = form;

  const handleChange = (event) => {
    changeInput(propName, event.target.value);
  };

  if (!schema?.[propName]) {
    return null;
  }

  return (
    <TextField
      margin="dense"
      id={propName}
      label={
        <GetLabel
          label={schema[propName].label}
          isRequired={isRequired(propName) ? " (Required)*" : ""}
        />
      }
      value={input[propName]}
      onChange={handleChange}
      style={{ width: "100%" }}
      error={invalid[propName] || (isRequired(propName) && !input[propName])}
      helperText={invalid[propName] ? schema[propName].errorMessage : ""}
      autoFocus={schema[propName].autoFocus}
      autoComplete="off" //This disables autofill, it can be overriden on case by case just by passing the prop
      {...passThroughProps}
    />
  );
}
